module.exports = __webpack_public_path__ + "img/Check-in-icon.18e74274.svg";